var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconDrawtoolFan = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.5 13.9935L7.61996 1.25L8.77985 1.71601L4.78559 11.6577L13.5872 3.33335L14.4461 4.24151L5.74835 12.4676L16.7166 8.84831L17.1083 10.0354L3.13014 14.6479L3.03645 14.5705L2.96433 14.5833L2.80138 14.3764L2.54747 14.1666L2.57019 14.0827L2.5 13.9935Z",
  fill: "#7F7F7F"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.8307 12.5H15.4141V17.5H16.2474V15H18.3307V14.1667H16.2474V13.3333H18.3307V12.5H16.2474H15.8307Z",
  fill: "#7F7F7F"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconDrawtoolFan);
export { ForwardRef as ReactComponent };